import { SlotSetting } from 'entities/Reservations';

export type Branche = {
  id: number;
  name: string;
  sendPhoneVerification: boolean;
  sendPauseMessage: boolean;
  useFaceScan: boolean;
  address: string;
  isDeleted: boolean;
  cellSetting: SlotSetting;
  operatingProcedure: string;
  useVisitorDoc: boolean;
  useTransportDoc: boolean;
};

export interface Role {
  id: number;
  name: RoleValues;
  title: string;
  branches: Branche[];
}

export type Routes = {
  [key in RoleValues]: string;
};

// eslint-disable-next-line no-shadow
export enum RoleValues {
  ARM_OHRANA = 'ARM_OHRANA',
  ARM_ORDERING = 'ARM_ORDERING',
  ARM_MANAGER = 'ARM_MANAGER',
  ARM_SUPERUSER = 'ARM_SUPERUSER',
  ARM_KIOSK = 'ARM_KIOSK',
  ARM_DIRECTOR = 'ARM_DIRECTOR',
  ARM_TVPANEL = 'ARM_TVPANEL',
  ARM_ADMINISTRATOR = 'ARM_ADMINISTRATOR',
}

export type RolesMode = '' | 'security' | 'ordering' | 'kioskMachine' | 'director';
